import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Select from "react-select";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardHeader
} from "reactstrap"
import {
    GET_NOTIFICATION_LIST,
  } from "../../helpers/data_helper";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import Loader from "../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import FlashDatePicker from "../../Components/Common/FlashDatePicker";
const notifyCustom = (msg, type) =>
  toast(msg, {
    position: "top-right",
    hideProgressBar: true,
    className: `bg-${type} text-white`,
  });
const NotificationConfig = () => {
    //const [selectedOutlets, setSelectedOutlets] = useState(false);
    const [notificationList, setNotificationList] = useState([]);
    const [notificationLoader,setNotificationLoader] = useState(false);
    const [selectedOutlets, setSelectedOutlets] = useState({});
    const [filterDateList, setFilterDateList] = useState([]);

    const { userInfo, outlets, currentOutlet, filterData } = useSelector(
      (state) => ({
        userInfo: state.UserOutletGroup.userInfo,
        outlets: state.UserOutletGroup.userOutlets,
        currentOutlet: state.UserOutletGroup.currentOutlet,
        filterData: state.Dashboard.filterData,
      }),
    );

    const [leftFilter, setLeftFilter] = useState(
      filterData.flash_date?.find((date) => date.default) || false,
    );

    useEffect(() => {
        if (filterData.flash_date) {
          setLeftFilter(
            (prev) => prev || filterData.flash_date.find((date) => date.default)
          );
          setFilterDateList(filterData.flash_date);
        }
      }, [filterData]);

    // console.log(outlets)
    const SingleOptions = Object.values(outlets).map((outlet) => ({
        value: outlet.outlet_id,
        label: outlet.outlet_name,
    }));
    const statusOptions = [
        { value: "Active", label: "Active" },
        { value: "Inactive", label: "Inactive" }
    ];
    const handleOutlet = (singleOption) => { 
         setSelectedOutlets(singleOption);
    };
    useEffect(()=>{
        if(currentOutlet.typeID && selectedOutlets==false){
            const defaultOutlet=SingleOptions.find((op)=>op.value==currentOutlet.typeID);
            if(defaultOutlet){
                setSelectedOutlets(defaultOutlet);
            }else{
                setSelectedOutlets(SingleOptions[0]);
            }
        }
    },[currentOutlet])
    const customStyles = {
        control: (provided) => ({
            ...provided,
            width: 260,
        }),
    };
   
    
    useEffect(() => {
    const controller = new AbortController();
        setNotificationLoader(true);

        postDataAPI({
            serviceName: GET_NOTIFICATION_LIST.serviceName,
            op: GET_NOTIFICATION_LIST.op,
            user_id: userInfo?.user_id || "",
        }, controller.signal).then((response) => {

            setNotificationLoader(false);

            if (response.status === "ok") {

                const formattedData = response.data.map((notification) => {

                    let nf_settings = null;
                    let selectedOutletOptions = [];

                    // ✅ 1. Extract outlets
                    if (notification.outlet_settings && notification.outlet_settings.length > 0) {

                        // 👉 get all outlet ids
                        const outletIds = notification.outlet_settings.map(o => o.outlet_id);

                        // 👉 map to react-select format
                        selectedOutletOptions = SingleOptions.filter(opt =>
                            outletIds.includes(Number(opt.value))
                        );

                        // 👉 take first nf_settings (same for all)
                        nf_settings = notification.outlet_settings[0]?.nf_settings
                            ? JSON.parse(notification.outlet_settings[0].nf_settings)
                            : null;
                    }

                    // ✅ 2. fallback default
                    if (!nf_settings) {
                        nf_settings = {
                            email: {
                                mon: { send: "n", time: "" },
                                tue: { send: "n", time: "" },
                                wed: { send: "n", time: "" },
                                thu: { send: "n", time: "" },
                                fri: { send: "n", time: "" },
                                sat: { send: "n", time: "" },
                                sun: { send: "n", time: "" }
                            },
                            notify: [],
                            sms: []
                        };
                    }

                    return {
                        ...notification,
                        nf_settings,
                        selectedOutlets: selectedOutletOptions,
                        nf_status: notification.nf_status || "Active"
                    };
                });

                setNotificationList(formattedData);
            }
        });

        return () => controller.abort();

    }, []);

    const handleOutletChange = (options, nf_id) => {
        setNotificationList(prev =>
            prev.map(n =>
                n.nf_id === nf_id
                    ? { ...n, selectedOutlets: options }
                    : n
            )
        );
    };
    const handleCheckboxChange = (event, nf_id) => {
        const { name, checked } = event.target;

        setNotificationList(prev =>
            prev.map(n => {
                if (n.nf_id === nf_id) {
                    return {
                        ...n,
                        nf_settings: {
                            ...n.nf_settings,
                            email: {
                                ...n.nf_settings.email,
                                [name]: {
                                    ...n.nf_settings.email[name],
                                    send: checked ? "y" : "n"
                                }
                            }
                        }
                    };
                }
                return n;
            })
        );
    };

    const handleSaveAll = async () => {
        setNotificationLoader(true);

        try {
            for (let notification of notificationList) {

                const outletsForRow = selectedOutlets[notification.nf_id] || [];

                await postDataAPI({
                    serviceName: GET_NOTIFICATION_LIST.serviceName,
                    op: GET_NOTIFICATION_LIST.save_op,
                    outletIDs: notification.selectedOutlets.map(o => o.value),
                    user_id: userInfo?.user_id || "",
                    nf_id: notification.nf_id,
                    nf_time: notification.nf_time,
                    nf_settings: JSON.stringify(notification.nf_settings),
                    nf_status: notification.nf_status,
                });
            }

            notifyCustom("Saved successfully!", "success");
        } catch (err) {
            notifyCustom("Save failed!", "danger");
        }

        setNotificationLoader(false);
    };
    const handleStatusChange = (option, nf_id) => {
        setNotificationList(prev =>
            prev.map(n =>
                n.nf_id === nf_id
                    ? { ...n, nf_status: option.value }
                    : n
            )
        );
    };

    const handleSendTestEmail = async (nf_id) => {
        setNotificationLoader(true);

        try {
            const response = await postDataAPI({
                serviceName: GET_NOTIFICATION_LIST.serviceName,
                op: GET_NOTIFICATION_LIST.op_test_email,
                nf_id: nf_id,
                user_id: userInfo?.user_id || "",
            });

            if (response.status === "ok") {
                notifyCustom(response.message || "Test email sent successfully!", "success");
            } else {
                notifyCustom(response.message || "Failed to send test email!", "danger");
            }
        } catch (err) {
            notifyCustom(err.message || "An error occurred while sending test email!", "danger");
        } finally {
            setNotificationLoader(false);
        }
    };

    const handleSendMonthEndEmail = async (nf_id) => {
        setNotificationLoader(true); 
        try {
            const response = await postDataAPI({
                serviceName: GET_NOTIFICATION_LIST.serviceName,
                op: GET_NOTIFICATION_LIST.op_month_end_email,
                nf_id: nf_id,
                user_id: userInfo?.user_id || "",
                leftFilter: leftFilter,
                outlet_ids: notificationList.find(n => n.nf_id === nf_id)?.selectedOutlets.map(o => o.value) || [],
            });
            if (response.status === "ok") {
                notifyCustom(response.message || "Month-end email sent successfully!", "success");
                const { file_name, pdf_file } = response.data;
                const blob = new Blob(
                [Uint8Array.from(atob(pdf_file), c => c.charCodeAt(0))],
                { type: "application/pdf" }
                );

                const url = URL.createObjectURL(blob);

                const a = document.createElement("a");
                a.href = url;
                a.download = file_name;
                a.click();

                URL.revokeObjectURL(url);
            } else {
                notifyCustom(response.message || "Failed to send month-end email!", "danger");
            }  
        } catch (err) {
            notifyCustom(err.message || "An error occurred while sending month-end email!", "danger");
        } finally {
            setNotificationLoader(false);
        }
    };

    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <CardHeader className="align-items-center ps-0">
                                    <div className="">
                                            <h4 className="card-title mb-1">
                                                Email Notification Settings
                                            </h4>
                                        </div>
                                </CardHeader>
                                <div className="mt-3 table-responsive">
                                    {notificationLoader && <Loader />}
                                    <table className={`table  table-bordered table-nowrap repeater ${notificationLoader ? "opacity-50" : ""}`}>
                                        <thead>
                                            <tr>
                                               
                                                <th scope="col">&nbsp;&nbsp; Reports&nbsp;&nbsp;</th>
                                                {/* <th scope="col" style={{ width: 100 }}> Time</th> */}
                                                <th>Outlets</th>
                                                <th scope="col">Mon</th>
                                                <th scope="col">Tue</th>
                                                <th scope="col">Wed</th>
                                                <th scope="col">Thu</th>
                                                <th scope="col">Fri</th>
                                                <th scope="col">Sat</th>
                                                <th scope="col">Sun</th>
                                                <th style={{ width: 140 }}>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {notificationList.filter((notification) => notification.nf_dev !== "month_end_notification").map((notification, index)=>{                                                 
                                                return <tr key={index}>
                                                    <td>
                                                        {notification.title}
                                                        {userInfo?.role_name === "PerfectCheck Admin" && (
                                                            <button 
                                                            className="btn btn-sm btn-outline-primary ms-2" 
                                                            onClick={() => handleSendTestEmail(notification.nf_id)}
                                                            disabled={notificationLoader}
                                                            >
                                                                Send Test Email
                                                            </button>
                                                        )}
                                                    </td>
                                                    {/* <td>{notification.nf_time} {notification.time_zone}</td> */}
                                                    <td style={{ minWidth: 250 }}>
                                                        <Select
                                                            isMulti
                                                            options={SingleOptions}
                                                            //value={selectedOutlets[notification.nf_id] || []}
                                                            value={notification.selectedOutlets || []}
                                                            onChange={(options) => handleOutletChange(options, notification.nf_id)}
                                                            menuPortalTarget={document.body}
                                                            menuPosition="fixed"
                                                            styles={{
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                       <input type="checkbox" name="mon" className="form-check-input mon" value="Yes" onChange={(event)=>handleCheckboxChange(event,notification.nf_id)} checked={notification?.nf_settings?.email?.mon?.send=='y'?true:false} />
                                                    </td>
                                                    <td>
                                                        <input type="checkbox" name="tue" className="form-check-input tue" value="Yes" onChange={(event)=>handleCheckboxChange(event,notification.nf_id)} checked={notification?.nf_settings?.email?.tue.send=='y'?true:false}/>
                                                    </td>
                                                    <td>
                                                        <input type="checkbox" name="wed" className="form-check-input wed" value="Yes" onChange={(event)=>handleCheckboxChange(event,notification.nf_id)} checked={notification?.nf_settings?.email?.wed.send=='y'?true:false}/>
                                                    </td>
                                                    <td>
                                                        <input type="checkbox" name="thu" className="form-check-input thu" value="Yes" onChange={(event)=>handleCheckboxChange(event,notification.nf_id)} checked={notification?.nf_settings?.email?.thu?.send=='y'?true:false}/>
                                                    </td>
                                                    <td>
                                                        <input type="checkbox" name="fri" className="form-check-input fri" value="Yes" onChange={(event)=>handleCheckboxChange(event,notification.nf_id)} checked={notification?.nf_settings?.email?.fri?.send=='y'?true:false}/>
                                                    </td>
                                                    <td>
                                                        <input type="checkbox" name="sat" className="form-check-input sat" value="Yes" onChange={(event)=>handleCheckboxChange(event,notification.nf_id)} checked={notification?.nf_settings?.email?.sat?.send=='y'?true:false}/>
                                                    </td>
                                                    <td>
                                                        <input type="checkbox" name="sun" className="form-check-input sun" value="Yes" onChange={(event)=>handleCheckboxChange(event,notification.nf_id)} checked={notification?.nf_settings?.email?.sun?.send=='y'?true:false}/>
                                                    </td>
                                                    <td style={{ minWidth: "140px" }}>
                                                        <Select
                                                            options={statusOptions}
                                                            value={statusOptions.find(s => s.value === notification.nf_status)}
                                                            onChange={(option) => handleStatusChange(option, notification.nf_id)}
                                                            menuPortalTarget={document.body}
                                                            menuPosition="fixed"
                                                            styles={{
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table> 
                                </div> 
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <small className="text-muted">
                                        Emails will be received at 8:00 AM in the outlet’s local timezone.
                                    </small>

                                    <button className="btn btn-primary" onClick={handleSaveAll}>
                                        Save Changes
                                    </button>
                                </div>

                                <hr />

                                <div className="mt-3">
                                    {notificationLoader && <Loader />}
                                    <table className={`table  table-bordered table-nowrap repeater ${notificationLoader ? "opacity-50" : ""}`}>
                                        <thead>
                                            <tr>
                                               
                                                <th scope="col">&nbsp;&nbsp; Report&nbsp;&nbsp;</th>
                                                <th>Outlets</th>
                                                <th scope="col">Month</th>
                                                <th style={{ width: 140 }}>Action</th>
                                            </tr>
                                        </thead>
                                       <tbody>
                                            {notificationList.filter((notification) => notification.nf_dev === "month_end_notification").map((notification, index)=>{                                                 
                                                return (
                                                  <tr key={index}>
                                                    <td style={{ width: "250px", minWidth: "250px", maxWidth: "250px" }}>
                                                      {notification.title}
                                                    </td>
                                                    <td style={{ width: "250px", minWidth: "250px", maxWidth: "250px" }}>
                                                      <Select
                                                        isMulti
                                                        options={SingleOptions}
                                                        //value={selectedOutlets[notification.nf_id] || []}
                                                        value={
                                                          notification.selectedOutlets ||
                                                          []
                                                        }
                                                        onChange={(options) =>
                                                          handleOutletChange(
                                                            options,
                                                            notification.nf_id,
                                                          )
                                                        }
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        menuPosition="fixed"
                                                        styles={{
                                                          menuPortal: (
                                                            base,
                                                          ) => ({
                                                            ...base,
                                                            zIndex: 9999,
                                                          }),
                                                        }}
                                                      />
                                                    </td>
                                                    <td style={{ width: "300px", minWidth: "300px", maxWidth: "300px" }}>
                                                      <FlashDatePicker
                                                        filterDateList={
                                                          filterDateList
                                                        }
                                                        activeDate={leftFilter}
                                                        setActiveDate={
                                                          setLeftFilter
                                                        }
                                                        posEnd={false}
                                                      />
                                                    </td>
                                                    <td>
                                                      <button
                                                        className="btn btn-primary"
                                                        onClick={() =>
                                                          handleSendMonthEndEmail(
                                                            notification.nf_id,
                                                          )
                                                        }
                                                        disabled={
                                                          notificationLoader ||
                                                          notification
                                                            .selectedOutlets
                                                            .length === 0 ||
                                                          !leftFilter
                                                        }
                                                      >
                                                        Download
                                                      </button>
                                                    </td>
                                                  </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table> 
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <ToastContainer />
        </div>
    )
}

export default NotificationConfig